import { imageUrlBuilder } from '@/utils/helpers';
import styled from 'styled-components';

const FigureContainer = styled.figure`
  margin: 0;
  display: flex;
  align-items: flex-start; /* this is a Safari fix to make images NOT stretch */
`;

const StyledImage = styled.img`
  margin: 0;
  margin-left: auto;
  margin-right: auto;
`;

const Figure = ({ image, alt, caption }) => {
  const imgSrc = image?.asset ? imageUrlBuilder.image(image.asset).width(800).auto('format').quality(80).url() : '';
  return (
    <FigureContainer>
      {image && image.asset && <StyledImage src={imgSrc} alt={alt || caption || ''} />}
      {caption && <figcaption>{caption}</figcaption>}
    </FigureContainer>
  );
};

export default Figure;
